import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Version = lazy(() =>
  import('./components/pages/Version').then(({Version}) => ({default: Version})),
)

export function VersionPage() {
  useDocumentTitle(t('Quiz LTI Version'))

  return (
    <Suspense>
      <Version />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the version module.
 */
export const versionRoutes = [
  {
    index: true,
    element: <VersionPage />,
  },
]
